import { Color } from '@dreryk/color-common-api';
import {
   PatientGroupAlreadyExistsFault,
   PatientGroupQuery,
   PatientGroupUpdateCommand,
} from '@dreryk/egabinet-patient-frontend-api';

import { refetchCqrsQuery, useCqrsCommand } from '@dreryk/command-query-react-common';
import { dispatchSnackbarPositiveEvent } from '@dreryk/react-components';

import { translationKeys } from '../../../translations';

import { CustomPatientGroupsUpdateFormBean } from './CustomPatientGroupsUpdateForm.types';

type CustomPatientGroupsUpdateActionRenderProps = {
   updateCustomPatientGroup: (formData: CustomPatientGroupsUpdateFormBean) => Promise<void>;
};

type CustomPatientGroupsUpdateActionProps = {
   children: (renderProps: CustomPatientGroupsUpdateActionRenderProps) => JSX.Element;
   groupId: number;
   onSuccess: VoidFunction;
   onPatientGroupAlreadyExistsFault: VoidFunction;
};

export const CustomPatientGroupsUpdateAction = (props: CustomPatientGroupsUpdateActionProps): JSX.Element => {
   const { executeAsync } = useCqrsCommand<void, CustomPatientGroupsUpdateFormBean, PatientGroupAlreadyExistsFault>(
      (parameters) => {
         const command = new PatientGroupUpdateCommand();
         command.id = props.groupId;
         command.name = parameters.name;
         command.primaryColor = Color.of(parameters.primaryColor);
         return command;
      },
      {
         onSuccess: () => {
            dispatchSnackbarPositiveEvent(translationKeys.changesHaveBeenSaved);
            refetchCqrsQuery(PatientGroupQuery);
            props.onSuccess();
         },
         onFault: {
            'egabinet-patient-frontend-api:PatientGroupAlreadyExistsFault': props.onPatientGroupAlreadyExistsFault,
         },
      }
   );

   return props.children({ updateCustomPatientGroup: executeAsync });
};
